import React, {
    useEffect,
    useState
} from "react";

import {
    Link
} from "react-router-dom";

import Swal from "sweetalert2";

import API_BASE_URL from "../config/api";

import QuillEditor from "../components/QuillEditor";


function AddPaperQuestion() {


    /*
    |--------------------------------------------------------------------------
    | API URLs
    |--------------------------------------------------------------------------
    */

    const API_URL =
        `${API_BASE_URL}/admin/paper-questions`;

    const SUBJECT_API =
        `${API_BASE_URL}/admin/paper-question-subjects`;

    const PAPER_API =
        `${API_BASE_URL}/admin/paper-question-papers`;


    /*
    |--------------------------------------------------------------------------
    | State
    |--------------------------------------------------------------------------
    */

    const [subjects, setSubjects] =
        useState([]);

    const [papers, setPapers] =
        useState([]);

    const [loadingData, setLoadingData] =
        useState(true);

    const [saving, setSaving] =
        useState(false);


    const [form, setForm] = useState({

        subject: "",

        paper: "",

        question: "",

        sort_order: "",

        option1: "",

        option2: "",

        option3: "",

        option4: "",

        right_option: "",

        explanation: ""

    });


    /*
    |--------------------------------------------------------------------------
    | Check Quill Content
    |--------------------------------------------------------------------------
    */

    const isQuillEmpty = (value) => {

        if (!value) {
            return true;
        }


        const tempDiv =
            document.createElement("div");


        tempDiv.innerHTML =
            value;


        const text =
            tempDiv.textContent ||
            tempDiv.innerText ||
            "";


        return text.trim() === "";

    };


    /*
    |--------------------------------------------------------------------------
    | Load Subjects + Papers
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const loadData = async () => {

            try {

                setLoadingData(true);


                const [
                    subjectResponse,
                    paperResponse
                ] = await Promise.all([

                    fetch(
                        SUBJECT_API,
                        {
                            method: "GET",

                            credentials: "include",

                            headers: {
                                Accept:
                                    "application/json"
                            }
                        }
                    ),

                    fetch(
                        PAPER_API,
                        {
                            method: "GET",

                            credentials: "include",

                            headers: {
                                Accept:
                                    "application/json"
                            }
                        }
                    )

                ]);


                /*
                |--------------------------------------------------------------------------
                | Subjects Response
                |--------------------------------------------------------------------------
                */

                const subjectData =
                    await subjectResponse.json();


                /*
                |--------------------------------------------------------------------------
                | Papers Response
                |--------------------------------------------------------------------------
                */

                const paperData =
                    await paperResponse.json();


                console.log(
                    "Subjects Response:",
                    subjectData
                );


                console.log(
                    "Papers Response:",
                    paperData
                );


                /*
                |--------------------------------------------------------------------------
                | Set Subjects
                |--------------------------------------------------------------------------
                */

                if (
                    subjectResponse.ok &&
                    subjectData.success
                ) {

                    setSubjects(
                        subjectData.data || []
                    );

                } else {

                    console.error(
                        "Subject API Error:",
                        subjectData
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Set Papers
                |--------------------------------------------------------------------------
                */

                if (
                    paperResponse.ok &&
                    paperData.success
                ) {

                    setPapers(
                        paperData.data || []
                    );

                } else {

                    console.error(
                        "Paper API Error:",
                        paperData
                    );

                }

            } catch (error) {

                console.error(
                    "Load Add Question Data:",
                    error
                );


                Swal.fire({

                    icon: "error",

                    title: "Error",

                    text:
                        "Unable to load subjects and papers."

                });

            } finally {

                setLoadingData(false);

            }

        };


        loadData();

    }, [SUBJECT_API, PAPER_API]);


    /*
    |--------------------------------------------------------------------------
    | Normal Input Change
    |--------------------------------------------------------------------------
    */

    const handleChange = (e) => {

        const {
            name,
            value
        } = e.target;


        setForm(prev => ({

            ...prev,

            [name]: value

        }));

    };


    /*
    |--------------------------------------------------------------------------
    | Question Editor Change
    |--------------------------------------------------------------------------
    */

    const handleQuestionChange = (value) => {

        setForm(prev => ({

            ...prev,

            question: value

        }));

    };


    /*
    |--------------------------------------------------------------------------
    | Explanation Editor Change
    |--------------------------------------------------------------------------
    */

    const handleExplanationChange = (value) => {

        setForm(prev => ({

            ...prev,

            explanation: value

        }));

    };


    /*
    |--------------------------------------------------------------------------
    | Submit
    |--------------------------------------------------------------------------
    */

    const handleSubmit = async (e) => {

        e.preventDefault();


        /*
        |--------------------------------------------------------------------------
        | Prevent Double Submit
        |--------------------------------------------------------------------------
        */

        if (saving) {
            return;
        }


        /*
        |--------------------------------------------------------------------------
        | Frontend Validation
        |--------------------------------------------------------------------------
        */

        if (!form.subject.trim()) {

            Swal.fire({

                icon: "warning",

                title: "Required",

                text:
                    "Please select subject."

            });

            return;

        }


        if (!form.paper.trim()) {

            Swal.fire({

                icon: "warning",

                title: "Required",

                text:
                    "Please enter paper."

            });

            return;

        }


        if (isQuillEmpty(form.question)) {

            Swal.fire({

                icon: "warning",

                title: "Required",

                text:
                    "Please enter question."

            });

            return;

        }


        if (
            form.sort_order === "" ||
            form.sort_order === null ||
            Number(form.sort_order) < 1
        ) {

            Swal.fire({

                icon: "warning",

                title: "Required",

                text:
                    "Please enter a valid sort order."

            });

            return;

        }


        if (!form.option1.trim()) {

            Swal.fire({

                icon: "warning",

                title: "Required",

                text:
                    "Please enter Option 1."

            });

            return;

        }


        if (!form.option2.trim()) {

            Swal.fire({

                icon: "warning",

                title: "Required",

                text:
                    "Please enter Option 2."

            });

            return;

        }


        if (!form.option3.trim()) {

            Swal.fire({

                icon: "warning",

                title: "Required",

                text:
                    "Please enter Option 3."

            });

            return;

        }


        if (!form.option4.trim()) {

            Swal.fire({

                icon: "warning",

                title: "Required",

                text:
                    "Please enter Option 4."

            });

            return;

        }


        if (!form.right_option) {

            Swal.fire({

                icon: "warning",

                title: "Required",

                text:
                    "Please select right option."

            });

            return;

        }


        if (isQuillEmpty(form.explanation)) {

            Swal.fire({

                icon: "warning",

                title: "Required",

                text:
                    "Please enter explanation."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Prepare Payload
        |--------------------------------------------------------------------------
        */

        const payload = {

            subject:
                form.subject.trim(),

            paper:
                form.paper.trim(),

            question:
                form.question,

            sort_order:
                Number(form.sort_order),

            option1:
                form.option1.trim(),

            option2:
                form.option2.trim(),

            option3:
                form.option3.trim(),

            option4:
                form.option4.trim(),

            right_option:
                String(form.right_option),

            explanation:
                form.explanation

        };


        console.log(
            "ADD QUESTION PAYLOAD:",
            payload
        );


        /*
        |--------------------------------------------------------------------------
        | Save Question
        |--------------------------------------------------------------------------
        */

        try {

            setSaving(true);


            const response =
                await fetch(
                    API_URL,
                    {
                        method: "POST",

                        credentials: "include",

                        headers: {

                            "Content-Type":
                                "application/json",

                            Accept:
                                "application/json"

                        },

                        body:
                            JSON.stringify(payload)

                    }
                );


            /*
            |--------------------------------------------------------------------------
            | Get Response Safely
            |--------------------------------------------------------------------------
            */

            const responseText =
                await response.text();


            console.log(
                "ADD QUESTION STATUS:",
                response.status
            );


            console.log(
                "ADD QUESTION RAW RESPONSE:",
                responseText
            );


            let data = {};


            try {

                data =
                    responseText
                        ? JSON.parse(responseText)
                        : {};

            } catch (jsonError) {

                console.error(
                    "JSON Parse Error:",
                    jsonError
                );


                throw new Error(
                    "Server returned an invalid response."
                );

            }


            console.log(
                "ADD QUESTION RESPONSE:",
                data
            );


            /*
            |--------------------------------------------------------------------------
            | Validation Error - 422
            |--------------------------------------------------------------------------
            */

            if (response.status === 422) {

                let message =
                    data.message ||
                    "Validation failed.";


                if (data.errors) {

                    const errors =
                        Object.entries(
                            data.errors
                        )
                        .map(
                            ([field, messages]) => {

                                return `
                                    <strong>
                                        ${field}
                                    </strong>
                                    : ${messages.join(", ")}
                                `;

                            }
                        )
                        .join("<br>");


                    message =
                        errors;

                }


                Swal.fire({

                    icon: "error",

                    title:
                        "Validation Failed",

                    html:
                        message

                });


                return;

            }


            /*
            |--------------------------------------------------------------------------
            | Unauthorized
            |--------------------------------------------------------------------------
            */

            if (response.status === 401) {

                Swal.fire({

                    icon: "warning",

                    title:
                        "Session Expired",

                    text:
                        "Your admin session has expired. Please login again."

                });


                return;

            }


            /*
            |--------------------------------------------------------------------------
            | Forbidden
            |--------------------------------------------------------------------------
            */

            if (response.status === 403) {

                Swal.fire({

                    icon: "error",

                    title:
                        "Access Denied",

                    text:
                        data.message ||
                        "You are not allowed to add questions."

                });


                return;

            }


            /*
            |--------------------------------------------------------------------------
            | Server Error
            |--------------------------------------------------------------------------
            */

            if (!response.ok) {

                console.error(
                    "Laravel Add Question Error:",
                    data
                );


                throw new Error(

                    data.error ||

                    data.message ||

                    `Unable to add question. Server returned ${response.status}.`

                );

            }


            /*
            |--------------------------------------------------------------------------
            | API Success Check
            |--------------------------------------------------------------------------
            */

            if (!data.success) {

                throw new Error(

                    data.error ||

                    data.message ||

                    "Unable to add question."

                );

            }


            /*
            |--------------------------------------------------------------------------
            | Success Message
            |--------------------------------------------------------------------------
            */

            await Swal.fire({

                icon: "success",

                title:
                    "Success",

                text:
                    data.message ||
                    "Question added successfully.",

                confirmButtonText:
                    "OK"

            });


            /*
            |--------------------------------------------------------------------------
            | Reset Form
            |
            | IMPORTANT:
            | Subject + Paper will remain selected.
            |--------------------------------------------------------------------------
            */

            setForm(prev => ({

                subject:
                    prev.subject,

                paper:
                    prev.paper,

                question:
                    "",

                sort_order:
                    "",

                option1:
                    "",

                option2:
                    "",

                option3:
                    "",

                option4:
                    "",

                right_option:
                    "",

                explanation:
                    ""

            }));


            /*
            |--------------------------------------------------------------------------
            | Do NOT navigate
            |--------------------------------------------------------------------------
            |
            | User will stay on Add Question page.
            |
            */


        } catch (error) {

            console.error(
                "Add Question Error:",
                error
            );


            Swal.fire({

                icon: "error",

                title:
                    "Add Question Failed",

                text:
                    error.message ||
                    "Unable to add question."

            });

        } finally {

            setSaving(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Loading Screen
    |--------------------------------------------------------------------------
    */

    if (loadingData) {

        return (

            <div
                className="
                    container-fluid
                    d-flex
                    justify-content-center
                    align-items-center
                "
                style={{
                    minHeight: "400px"
                }}
            >

                <div className="text-center">

                    <div
                        className="
                            spinner-border
                            text-primary
                        "
                    ></div>


                    <div className="mt-3 text-muted">

                        Loading...

                    </div>

                </div>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | Page
    |--------------------------------------------------------------------------
    */

    return (

        <div
            className="container-fluid"
            style={{
                maxHeight: "85vh",
                overflowY: "auto"
            }}
        >


            {/* Page Header */}

            <div
                className="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-4
                "
            >

                <div>

                    <h3 className="mb-1">

                        <i className="fa fa-pencil me-2"></i>

                        Add Question

                    </h3>


                    <p className="text-muted mb-0">

                        Add study material question

                    </p>

                </div>


                <Link
                    to="/paperquestions"
                    className="
                        btn
                        btn-outline-secondary
                    "
                >

                    <i className="fa fa-arrow-left me-2"></i>

                    Back

                </Link>

            </div>


            {/* Card */}

            <div
                className="
                    card
                    shadow-sm
                "
                style={{
                    borderTop:
                        "2px solid #bfbfbf"
                }}
            >


                {/* Card Header */}

                <div
                    className="
                        card-header
                        bg-white
                    "
                >

                    <h5 className="mb-0">

                        <i className="fa fa-pencil me-2"></i>

                        Add Question

                    </h5>

                </div>


                {/* Form */}

                <form
                    onSubmit={handleSubmit}
                >

                    <div className="card-body">


                        {/* Subject */}

                        <div className="row mb-3">

                            <label
                                className="
                                    col-md-2
                                    col-form-label
                                    fw-semibold
                                "
                            >

                                Subject

                            </label>


                            <div className="col-md-10">

                                <select
                                    name="subject"
                                    className="form-select"
                                    value={form.subject}
                                    onChange={handleChange}
                                >

                                    <option value="">

                                        -----Select Subject-----

                                    </option>


                                    {subjects.map(
                                        (item) => (

                                            <option
                                                key={
                                                    item.id
                                                }
                                                value={
                                                    item.subject_name
                                                }
                                            >

                                                {
                                                    item.subject_name
                                                }

                                            </option>

                                        )
                                    )}

                                </select>

                            </div>

                        </div>


                        {/* Paper */}

                        <div className="row mb-3">

                            <label
                                className="
                                    col-md-2
                                    col-form-label
                                    fw-semibold
                                "
                            >

                                Paper

                            </label>


                            <div className="col-md-10">

                                <input
                                    type="text"
                                    name="paper"
                                    list="papers"
                                    className="form-control"
                                    placeholder="Ex. Paper 1 or Sample Paper"
                                    value={form.paper}
                                    onChange={handleChange}
                                />


                                <datalist
                                    id="papers"
                                >

                                    {papers.map(
                                        (item, index) => (

                                            <option
                                                key={index}
                                                value={
                                                    item.paper
                                                }
                                            />

                                        )
                                    )}

                                </datalist>

                            </div>

                        </div>


                        {/* Question */}

                        <div className="row mb-3">

                            <label
                                className="
                                    col-md-2
                                    col-form-label
                                    fw-semibold
                                "
                            >

                                Question

                            </label>


                            <div className="col-md-10">

                                <QuillEditor
                                    value={
                                        form.question
                                    }
                                    onChange={
                                        handleQuestionChange
                                    }
                                />

                            </div>

                        </div>


                        {/* Sort Order */}

                        <div className="row mb-3">

                            <label
                                className="
                                    col-md-2
                                    col-form-label
                                    fw-semibold
                                "
                            >

                                Sort Order

                            </label>


                            <div className="col-md-10">

                                <input
                                    type="number"
                                    name="sort_order"
                                    className="form-control"
                                    placeholder="Sort Order"
                                    min="1"
                                    value={
                                        form.sort_order
                                    }
                                    onChange={
                                        handleChange
                                    }
                                />

                            </div>

                        </div>


                        {/* ================================================== */}
                        {/* OPTION 1 + OPTION 2 */}
                        {/* ================================================== */}

                        <div className="row mb-3">


                            {/* Option 1 */}

                            <div className="col-md-6">

                                <div className="row">

                                    <label
                                        className="
                                            col-md-4
                                            col-form-label
                                            fw-semibold
                                        "
                                    >

                                        Option 1

                                    </label>


                                    <div className="col-md-8">

                                        <input
                                            type="text"
                                            name="option1"
                                            className="form-control"
                                            placeholder="Option 1"
                                            maxLength="80"
                                            value={
                                                form.option1
                                            }
                                            onChange={
                                                handleChange
                                            }
                                        />

                                    </div>

                                </div>

                            </div>


                            {/* Option 2 */}

                            <div className="col-md-6">

                                <div className="row">

                                    <label
                                        className="
                                            col-md-4
                                            col-form-label
                                            fw-semibold
                                        "
                                    >

                                        Option 2

                                    </label>


                                    <div className="col-md-8">

                                        <input
                                            type="text"
                                            name="option2"
                                            className="form-control"
                                            placeholder="Option 2"
                                            maxLength="80"
                                            value={
                                                form.option2
                                            }
                                            onChange={
                                                handleChange
                                            }
                                        />

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* ================================================== */}
                        {/* OPTION 3 + OPTION 4 */}
                        {/* ================================================== */}

                        <div className="row mb-3">


                            {/* Option 3 */}

                            <div className="col-md-6">

                                <div className="row">

                                    <label
                                        className="
                                            col-md-4
                                            col-form-label
                                            fw-semibold
                                        "
                                    >

                                        Option 3

                                    </label>


                                    <div className="col-md-8">

                                        <input
                                            type="text"
                                            name="option3"
                                            className="form-control"
                                            placeholder="Option 3"
                                            maxLength="80"
                                            value={
                                                form.option3
                                            }
                                            onChange={
                                                handleChange
                                            }
                                        />

                                    </div>

                                </div>

                            </div>


                            {/* Option 4 */}

                            <div className="col-md-6">

                                <div className="row">

                                    <label
                                        className="
                                            col-md-4
                                            col-form-label
                                            fw-semibold
                                        "
                                    >

                                        Option 4

                                    </label>


                                    <div className="col-md-8">

                                        <input
                                            type="text"
                                            name="option4"
                                            className="form-control"
                                            placeholder="Option 4"
                                            maxLength="80"
                                            value={
                                                form.option4
                                            }
                                            onChange={
                                                handleChange
                                            }
                                        />

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* Right Option */}

                        <div className="row mb-3">

                            <label
                                className="
                                    col-md-2
                                    col-form-label
                                    fw-semibold
                                "
                            >

                                Right Option

                            </label>


                            <div className="col-md-10">

                                <select
                                    name="right_option"
                                    className="form-select"
                                    value={
                                        form.right_option
                                    }
                                    onChange={
                                        handleChange
                                    }
                                >

                                    <option value="">

                                        -----Select Right Option-----

                                    </option>


                                    <option value="1">

                                        Option 1

                                    </option>


                                    <option value="2">

                                        Option 2

                                    </option>


                                    <option value="3">

                                        Option 3

                                    </option>


                                    <option value="4">

                                        Option 4

                                    </option>

                                </select>


                                <small className="text-muted">

                                    Select the correct option number.

                                </small>

                            </div>

                        </div>


                        {/* Explanation */}

                        <div className="row mb-3">

                            <label
                                className="
                                    col-md-2
                                    col-form-label
                                    fw-semibold
                                "
                            >

                                Explanation

                            </label>


                            <div className="col-md-10">

                                <QuillEditor
                                    value={
                                        form.explanation
                                    }
                                    onChange={
                                        handleExplanationChange
                                    }
                                />

                            </div>

                        </div>


                    </div>


                    {/* Footer */}

                    <div
                        className="
                            card-footer
                            bg-white
                            text-end
                        "
                    >

                        <Link
                            to="/paperquestions"
                            className="
                                btn
                                btn-secondary
                                me-2
                            "
                        >

                            Cancel

                        </Link>


                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={saving}
                        >

                            {saving ? (

                                <>

                                    <span
                                        className="
                                            spinner-border
                                            spinner-border-sm
                                            me-2
                                        "
                                    ></span>

                                    Saving...

                                </>

                            ) : (

                                <>

                                    <i className="fa fa-save me-2"></i>

                                    Save Question

                                </>

                            )}

                        </button>

                    </div>

                </form>

            </div>

        </div>

    );

}


export default AddPaperQuestion;